import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { initialState } from 'store/slices/initialStateSlice';
import { ROUTE_PATHS } from '../../routes';
import { RootState } from '../../store/index';

export default function ProtectedRoute({
  children,
}: {
  children: JSX.Element;
}) {
  const { isAuthenticated: isAuth0Authenticated, isLoading } = useAuth0();

  const user = useSelector((state: RootState) => state.user);
  const token = useSelector((state: RootState) => state.user.token);

  const isAuthenticated = !!user && !!token;

  const isFullyAuthenticated =
    isAuthenticated || (isAuth0Authenticated && token);

  if (!initialState.oauth) {
    return children;
  }

  if (!isFullyAuthenticated && !isLoading) {
    return <Navigate to={ROUTE_PATHS.LOGIN} />;
  }

  return !!token ? children : null;
}
